import { t } from '@lingui/core/macro'
import { useMemo, useState } from 'react'
import ChartBarsInsight from '~/components/chart_bars_insight'
import ECharts from '~/components/echarts'
import AWSPatchManagerFilters from '~/dashboard/aws_patch_manager_filters'
import {
  awsPatchManagerComplianceSummaryChartPath,
  awsPatchManagerDailyComplianceSummaryChartPath,
  awsPatchManagerDailyNoncompliancePatchCountsChartPath,
  awsPatchManagerNonComplianceChartPath,
} from '~/routes'

export default function AWSPatchManagerDashboardCharts({ organizationId: orgId }) {
  const [chartParams, setChartParams] = useState({})

  // memoize URLs to prevent rerenders
  const complianceSummarytUrl = useMemo(() => awsPatchManagerComplianceSummaryChartPath(orgId), [orgId])
  const nonComplianceUrl = useMemo(() => awsPatchManagerNonComplianceChartPath(orgId), [orgId])
  const dailyComplianceUrl = useMemo(() => awsPatchManagerDailyComplianceSummaryChartPath(orgId), [orgId])
  const dailyNonComplianceUrl = useMemo(() => awsPatchManagerDailyNoncompliancePatchCountsChartPath(orgId), [orgId])

  return (
    <div className='card'>
      <div className='card-body'>
        <AWSPatchManagerFilters organizationId={orgId} setChartParams={setChartParams} />
        <div className='row gy-4'>
          <div className='col-sm-6'>
            <ECharts
              title={t`Compliance Summary`}
              chartInfoTitle='aws_patch_manager_compliance_summary'
              url={complianceSummarytUrl}
              params={chartParams}
            />
          </div>

          <div className='col-sm-6'>
            <ChartBarsInsight title={t`Noncompliance counts`} url={nonComplianceUrl} params={chartParams} />
          </div>

          <div className='col-sm-6'>
            <ECharts
              title={t`Historical compliance trends`}
              chartInfoTitle='aws_patch_manager_historical_compliance_trends'
              url={dailyComplianceUrl}
              params={chartParams}
              showExportButton
            />
          </div>

          <div className='col-sm-6'>
            <ECharts
              title={t`Historical noncompliance counts`}
              chartInfoTitle='aws_patch_manager_historical_noncompliance_counts'
              url={dailyNonComplianceUrl}
              params={chartParams}
              showExportButton
            />
          </div>
        </div>
      </div>
    </div>
  )
}
